import InfoIcon from "@mui/icons-material/Info";
import { Box, Button, Typography } from "@mui/material";

interface GuestOrderBannerProps {
  onOrderAsGuest: () => void;
}

export const GuestOrderBanner = ({ onOrderAsGuest }: GuestOrderBannerProps) => {
  return (
    <Box sx={{ p: 2, borderRadius: 1.5, bgcolor: "info.lighter" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <InfoIcon sx={{ color: "info.main", fontSize: 20 }} />
        <Typography variant="body1Semibold">Guest Ordering</Typography>
      </Box>
      <Typography variant="body2" sx={{ mt: 0.5, ml: "28px" }}>
        Just visiting? Order as a guest - no Teamworks account needed.
      </Typography>
      <Box sx={{ mt: 2, ml: "28px" }}>
        <Button
          variant="contained"
          size="small"
          onClick={onOrderAsGuest}
          sx={{
            whiteSpace: "nowrap",
            bgcolor: "common.black",
            color: "common.white",
            "&:hover": { bgcolor: "common.black" },
          }}
        >
          Order as Guest
        </Button>
      </Box>
    </Box>
  );
};
